export default "__VITE_ASSET__CHsqJYlA__"